import { Box, Grid } from '@mui/material'
import Divider from '@rentspree/component-2023.components.atoms.divider'
import { Typography } from '@rentspree/component-2023.components.atoms.typography'

import { FooterFollowUs } from './footer-follow-us'
import { FooterRightsReserved } from './footer-rights-reserved'
import { FooterSoc2Certified } from './footer-soc2-certified'
import styles from './footer.module.scss'

const RENTSPREE_LOGO = 'https://cdn.rentspree.com/static-files/logo/rentspree-logo-primary.png'

export const Footer: React.FC = () => (
  <Box className={styles.footerContainer}>
    <Divider />
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Box className={styles.footerAboutRentSpree}>
          <Box>
            <img src={RENTSPREE_LOGO} alt="footer-rentspree-logo" height="24px" width="auto" />
          </Box>
          <Typography variant="body">
            RentSpree provides award-winning tenant screening, leasing, and payment tools to make
            rentals simple. We create lasting connections among agents, landlords, and renters.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <FooterFollowUs />
      </Grid>
    </Grid>
    <FooterSoc2Certified />
    <FooterRightsReserved />
  </Box>
)
